import { Component, Input, Output, EventEmitter } from '@angular/core';
import { LiteratureDocument } from '@types';
import { Observable } from 'rxjs';

/**
 * thumbnails received from complimentary-literature-component is displayed here
 * includes data for complimentary, mandatory and share holder material
 */
@Component({
  selector: 'ft-literature-complementary-common',
  templateUrl: './complementary-common.component.html',
})
export class ComplementaryCommonComponent {
  @Input() isHandheld$: Observable<boolean>;
  @Input() isMobile$: Observable<boolean>;
  @Input() thumbnails$: Observable<LiteratureDocument[]>;
  @Output() thumbnailClick = new EventEmitter<string>();
  @Input() title: string;
  @Input() titleLinkBase: string;
  @Input() subTitle: string;
  @Input() downloadButtonText: string;

  getDetailsLink(thumbnail: LiteratureDocument): string {
    return `${this.titleLinkBase}/${thumbnail?.docId}`;
  }

  getDescription(description: string) {
    return `<p>${description}</p>`;
  }
}
